import { Helmet } from "react-helmet-async";
import { DEFAULT_OG_IMAGE } from "@/lib/site";

export const DEFAULT_TITLE = "AERWEAR | After Hours Athletics";
export const DEFAULT_DESCRIPTION = "Luxury athletic streetwear. Built for motion. After hours athletics.";

// Per-page title, description, canonical, Open Graph / Twitter tags and optional JSON-LD.
// index.html carries default copies for non-JS crawlers; src/index.js removes them on load.
export default function SEO({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_OG_IMAGE,
  type = "website",
  product,
  jsonLd,
  noindex = false,
  path,
}) {
  const pageUrl = window.location.origin + (path || window.location.pathname);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={pageUrl} />
      {noindex && <meta name="robots" content="noindex" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:site_name" content="AERWEAR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {product && <meta property="product:price:amount" content={product.price?.toFixed(2)} />}
      {product && <meta property="product:price:currency" content="USD" />}
      {product && <meta property="product:availability" content={product.available === false ? "out of stock" : "in stock"} />}

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
